const dataSchema = [
  {
    "title": "is_business",
    "type": "boolean",
    "content": {
      "label": "Are you a business?",
      "helpText": "Are you filling this out as a business or as an individual user?",
      "validation": {
        "required": true
      }
    }
  },
  {
    "title": "type_of_project",
    "type": "dropDown",
    "value": "",
    "content": {
      "helpText": "What type of project are you working on?",
      "validation": {
        "required": true,
        "enum": [
          "Side hustle",
          "Freelancer",
          "Hobby"
        ]
      }
    },
    "dependsOn": {
      "field": "is_business",
      "value": "false"
    }
  },
  {
    "title": "company_name",
    "type": "string",
    "content": {
      "helpText": "What is the name of your organization/business?",
      "validation": {
        "required": true,
        "minLength": 2
      }
    },
    "dependsOn": {
      "field": "is_business",
      "value": "true"
    }
  },
  {
    "title": "company_website",
    "type": "string",
    "content": {
      "helpText": "Your company website URL",
      "validation": {
        "required": false,
        "pattern": "^(https?:\\/\\/)?([\\w\\-])+\\.([\\w\\-])+([\\w\\-./?%&=]*)?$",
        "patternMessage": "Please enter a valid URL."
      }
    },
    "dependsOn": {
      "field": "is_business",
      "value": "true"
    }
  },
  {
    "title": "company_facebook",
    "type": "string",
    "content": {
      "helpText": "Your company Facebook page URL",
      "validation": {
        "required": false,
        "pattern": "^(https?:\\/\\/)?(www\\.)?facebook\\.com\\/.+$",
        "patternMessage": "Please enter a valid Facebook page link."
      }
    },
    "dependsOn": {
      "field": "is_business",
      "value": "true"
    }
  },
  {
    "title": "industry",
    "type": "dropDown",
    "value": "",
    "content": {
      "helpText": "Which industry best describes your business?",
      "validation": {
        "required": true,
        "enum": [
          "Technology & Software",
          "E-commerce & Retail",
          "Education",
          "Healthcare",
          "Finance & Banking",
          "Marketing & Advertising",
          "Consulting",
          "Manufacturing",
          "Hospitality & Tourism",
          "Non-profit",
          "Real Estate",
          "Automotive",
          "Media & Entertainment",
          "Construction",
          "Agriculture",
          "Legal Services",
          "Government",
          "Other"
        ]
      }
    },
  },
  {
    "title": "industry_other_description",
    "type": "string",
    "content": {
      "helpText": "Please specify your industry.",
      "validation": {
        "required": true
      }
    },
    "dependsOn": {
      "field": "industry",
      "value": "Other"
    }
  },
  {
    "title": "company_size",
    "type": "dropDown",
    "value": "",
    "content": {
      "helpText": "How many employees does your company have?",
      "validation": {
        "required": true,
        "enum": [
          "1-10",
          "11-50",
          "51-200",
          "201-500",
          "501-1000",
          "1000+"
        ]
      }
    },
    "dependsOn": {
      "field": "is_business",
      "value": "true"
    }
  },
  {
    "title": "experience_level",
    "type": "dropDown",
    "value": "",
    "content": {
      "helpText": "What is your experience level?",
      "validation": {
        "required": true,
        "enum": [
          "Beginner (0-2 years)",
          "Intermediate (3-5 years)",
          "Advanced (6-10 years)",
          "Expert (10+ years)",
          "Executive/Leadership"
        ]
      }
    }
  },
  {
    "title": "business_type",
    "type": "dropDown",
    "value": "",
    "content": {
      "helpText": "What type of business model do you operate?",
      "validation": {
        "required": false,
        "enum": [
          "B2B",
          "B2C",
          "B2B2C",
          "SaaS",
          "E-commerce",
          "Service-based",
          "Product-based",
          "Marketplace",
          "Agency",
          "Startup",
          "Enterprise"
        ]
      }
    },
    "dependsOn": {
      "field": "is_business",
      "value": "true"
    }
  },
  {
    "title": "project_type",
    "type": "dropDown",
    "value": "",
    "content": {
      "helpText": "What type of business model do you operate?",
      "validation": {
        "required": false,
        "enum": [
          "B2B",
          "B2C",
          "B2B2C",
          "SaaS",
          "E-commerce",
          "Service-based",
          "Product-based",
          "Marketplace",
          "Agency",
          "Startup",
          "Enterprise"
        ]
      }
    },
    "dependsOn": {
      "field": "is_business",
      "value": "false"
    }
  },
  {
    "title": "location",
    "type": "string",
    "content": {
      "helpText": "Where are you located? (City, Country)",
      "validation": {
        "required": false
      }
    }
  },
  {
    "title": "preferred_language",
    "type": "dropDown",
    "value": "en",
    "content": {
      "helpText": "What is your preferred language?",
      "validation": {
        "required": false,
        "enum": [
          "en",
          "es",
          "fr",
          "de",
          "it",
          "pt",
          "zh",
          "ja",
          "ko",
          "ar",
          "hi",
          "ru",
          "nl",
          "sv",
          "da",
          "no",
          "fi",
          "pl",
          "tr",
          "vi"
        ]
      }
    }
  },
  {
    "title": "key_interests",
    "type": "string",
    "content": {
      "helpText": "What are your key interests or areas of focus? (Enter multiple, separated by commas)",
      "validation": {
        "required": false,
        "multiline": true
      }
    }
  },
  {
    "title": "technical_skills",
    "type": "string",
    "content": {
      "helpText": "What are your technical skills? (Enter multiple, separated by commas)",
      "validation": {
        "required": false,
        "multiline": true
      }
    }
  },
  {
    "title": "current_challenges",
    "type": "string",
    "content": {
      "helpText": "What are the biggest challenges your business is facing right now?",
      "validation": {
        "required": true,
        "multiline": true
      }
    },
    "dependsOn": {
      "field": "is_business",
      "value": "true"
    }
  },
  {
    "title": "saas_goals",
    "type": "string",
    "content": {
      "helpText": "What are your goals for using SmartSaaS?",
      "validation": {
        "required": true,
        "multiline": true
      }
    },
    "dependsOn": {
      "field": "is_business",
      "value": "true"
    }
  },
  {
    "title": "decision_maker",
    "type": "boolean",
    "content": {
      "helpText": "Are you the primary decision maker for purchasing SaaS solutions?",
      "validation": {
        "required": true
      }
    },
    "dependsOn": {
      "field": "is_business",
      "value": "true"
    }
  },
  {
    "title": "budget_range",
    "type": "dropDown",
    "value": "",
    "content": {
      "helpText": "What is your estimated monthly budget for SaaS tools?",
      "validation": {
        "required": true,
        "enum": [
          "< £100",
          "£100 - £500",
          "£500 - £2000",
          "£2000 - £5000",
          "£5000+"
        ]
      }
    },
    "dependsOn": {
      "field": "is_business",
      "value": "true"
    }
  },
  {
    "title": "occupation",
    "type": "string",
    "content": {
      "helpText": "What is your current occupation or main area of work/study?",
      "validation": {
        "required": true
      }
    },
    "dependsOn": {
      "field": "is_business",
      "value": "false"
    }
  },
  {
    "title": "personal_goals_with_saas",
    "type": "string",
    "content": {
      "helpText": "What are your main goals for using Smartsaas?",
      "validation": {
        "required": false,
        "multiline": true
      }
    },
    "dependsOn": {
      "field": "is_business",
      "value": "false"
    }
  },
  {
    "title": "use_crm",
    "type": "boolean",
    "content": {
      "helpText": "Do you use a CRM or any other customer management system (Salesforce, HubSpot or even Excel to manage customers)?",
      "validation": {
        "required": true
      }
    }
  },
  {
    "title": "crm_provider",
    "type": "dropDown",
    "value": "",
    "content": {
      "helpText": "Which CRM do you use?",
      "validation": {
        "required": true,
        "enum": [
          "Salesforce",
          "HubSpot",
          "Zoho CRM",
          "Pipedrive",
          "Microsoft Dynamics",
          "Freshsales",
          "Other custom built"
        ]
      }
    },
    "dependsOn": {
      "field": "use_crm",
      "value": "true"
    }
  },
  {
    "title": "feature_list",
    "type": "group",
    "content": {
      "fields": [
        {
          "title": "feature_analytics",
          "type": "boolean",
          "content": {
            "helpText": "Do you use Analytics?"
          }
        },
        {
          "title": "what_feature_analytics",
          "type": "string",
          "content": {
            "helpText": "What software do you use for feature analytics?"
          },
          "dependsOn": {
            "field": "feature_analytics",
            "value": "true"
          }
        },
        {
          "title": "feature_email_marketing",
          "type": "boolean",
          "content": {
            "helpText": "Do you use Email Marketing tools?"
          }
        },
        {
          "title": "what_email_marketing",
          "type": "string",
          "content": {
            "helpText": "What software do you use for Email Marketing"
          },
          "dependsOn": {
            "field": "feature_email_marketin",
            "value": "true"
          }
        },
        {
          "title": "feature_project_management",
          "type": "boolean",
          "content": {
            "helpText": "Do you use Project Management tools?"
          }
        },
        {
          "title": "what_project_management",
          "type": "string",
          "content": {
            "helpText": "What software do you use for Project Management"
          },
          "dependsOn": {
            "field": "feature_project_management",
            "value": "true"
          }
        },
        {
          "title": "feature_automation",
          "type": "boolean",
          "content": {
            "helpText": "Do you use Automation tools?"
          }
        }, 
        {
          "title": "what_automation",
          "type": "string",
          "content": {
            "helpText": "What software do you use for Automation"
          },
          "dependsOn": {
            "field": "feature_automation",
            "value": "true"
          }
        },
        {
          "title": "feature_invoicing",
          "type": "boolean",
          "content": {
            "helpText": "Do you use Invoicing or Billing tools?"
          }
        },
        {
          "title": "what_invoicing",
          "type": "string",
          "content": {
            "helpText": "What software do you use for Invoicing?"
          },
          "dependsOn": {
            "field": "feature_invoicing",
            "value": "true"
          }
        }
      ]
    }
  }
];
export default dataSchema;